<template>
  <dialog ref="dialog" class="scale-up-bottom">
  <font v-if="!!title" class="headline" size="4">{{title}}</font><br v-if="!!title"/><br v-if="!!title"/>
  <font class="headline" size="3">{{ message }}</font>
    <form method="dialog">
      <input id="submitButton" class="mdl-button mdl-js-button mdl-button--primary" type="submit" :value="positiveAction" @click="acceptDialog" />
      <input id="cancelButton" v-if="cancellable" class="mdl-button mdl-js-button mdl-button--primary" type="submit" :value="cancelAction" @click="cancelDialog" />
    </form>
  </dialog>
</template>

<script>
  import dialogPolyfill from 'dialog-polyfill'

  export default {
    methods: {
      cancelDialog () {
        this.$emit('dialogCancelled')
      },
      acceptDialog () {
        this.$emit('dialogAccepted')
      }
    },
    mounted () {
      this.$nextTick(function () {
        dialogPolyfill.registerDialog(this.$refs.dialog)
      })
    },
    props: {
      status: {
        type: String,
        required: true,
        default: 'closed'
      },
      title: {
        type: String,
        default: null
      },
      message: {
        type: String,
        required: true,
        default: ''
      },
      positiveAction: {
        type: String,
        required: true,
        default: 'OK'
      },
      cancelAction: {
        type: String,
        default: 'CANCEL'
      },
      cancellable: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      status: function (newVal) {
        if (newVal === 'opened') {
          let dialog = document.querySelector('dialog')
          dialogPolyfill.registerDialog(dialog)
          dialog.showModal()
        }
      }
    }
  }
</script>

<style scoped>
  @import url(../../node_modules/dialog-polyfill/dialog-polyfill.css);

  dialog {
    padding-left: 30px;
    padding-right: 30px;
    padding-top: 30px;
    border: none;
    border-radius: 5px;
    box-shadow: 0 16px 32px rgba(0, 0, 0, 0.4);
    background-color: var(--bg-color-el-1);
    color:  var(--text-color-primary);
  }

  dialog>form>input[type="submit"] {
    margin-top: 20px;
    float: right;
  }

  dialog::backdrop {
    background-color: rgba(0, 0, 0, 0.7);
  }

  .scale-up-bottom {
    -webkit-animation: scale-up-bottom 0.2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
            animation: scale-up-bottom 0.2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  }

  @-webkit-keyframes scale-up-bottom {
    0% {
      -webkit-transform: scale(0.5);
              transform: scale(0.5);
      -webkit-transform-origin: 50% 100%;
              transform-origin: 50% 100%;
    }
    100% {
      -webkit-transform: scale(1);
              transform: scale(1);
      -webkit-transform-origin: 50% 100%;
              transform-origin: 50% 100%;
    }
  }
  @keyframes scale-up-bottom {
    0% {
      -webkit-transform: scale(0.5);
              transform: scale(0.5);
      -webkit-transform-origin: 50% 100%;
              transform-origin: 50% 100%;
    }
    100% {
      -webkit-transform: scale(1);
              transform: scale(1);
      -webkit-transform-origin: 50% 100%;
              transform-origin: 50% 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/DialogComponent.vue